import React from 'react';
import ReactPlayer from 'react-player/lazy';
import EditIcon from '@material-ui/icons/Edit';
import { IconButton } from '@material-ui/core';
import VideoDialog from './VideoDialog';
import AppContext from '../AppContext';
import axios from 'axios';
import { externalServerUrl } from '../../server/constants';
import { useRouter } from 'next/router';
import { useAuth } from '../../lib/useAuth';
import { initFalse } from '../../utils/constants';

interface VideoProps {
  className?: string,
  height?: string,
  light?: boolean,
  sectionId: string,
  videoUrl: string,
  width?: string,
}

export default function Video(props: VideoProps) {
  const {className, light, sectionId, videoUrl} = props;
  const appContext: any = React.useContext(AppContext);
  const router = useRouter();
  let {user} = useAuth();
  const isLoggedIn: any = user && user.isLoggedIn;
  const [open, setOpen] = React.useState(initFalse);
  const [isPlaying, setIsPlaying] = React.useState<boolean>(initFalse);

  const save = async (url: string) => {
    let pageObj = JSON.parse(appContext.content);
    pageObj[sectionId] = url;

    const payload = {
      id: appContext.id,
      content: JSON.stringify(pageObj),
      templateId: appContext.templateId,
      status: appContext.status
    };
    await axios.put(`${externalServerUrl}/api/pages`, payload);
    return router.replace(router.asPath);
  };

  const handleClickPreview = () => {
    setIsPlaying(true);
  };

  return (
    <span className="showEditIconForVideo">
      {
        isLoggedIn &&
        <IconButton aria-label="edit" className={"floatRight editBtnVideoBlue"} onClick={() => setOpen(true)}>
          <EditIcon/>
        </IconButton>
      }
      {
        open &&
        <VideoDialog
          url={videoUrl}
          onClose={() => setOpen(initFalse)}
          onSave={(url: string) => {
            setOpen(initFalse);
            return save(url);
          }}
        />
      }
      <ReactPlayer
        className={className}
        controls={!initFalse}
        light={light === initFalse ? light : !initFalse}
        loop={!initFalse}
        onClickPreview={handleClickPreview}
        playing={isPlaying}
        playsinline={!initFalse}
        url={videoUrl}
      />
    </span>
  );
}
